import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FamilyTreeStoreEffects } from './effects';
import { StoreModule } from '@ngrx/store';
import { familyTreeReducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature('FamilyTree', familyTreeReducer), EffectsModule.forFeature([FamilyTreeStoreEffects])],
  providers: [FamilyTreeStoreEffects],
})
export class FamilyTreeStoreModule {}
